module.exports = __webpack_public_path__ + "media/flags/ke-48e2f2cb.svg";